import { ReactNode } from 'react';
import { css } from './BulletPoint.css';

export const BulletPoint = ({ children }: IBulletPointProps) => {
  return (
    <li className={css.bullet}>
      <span>{children}</span>
    </li>
  );
};

export interface IBulletPointProps {
  children?: ReactNode;
}
